import { useCallback } from "react";
import { getUserInfoByInit } from "@/handle/request/register/event";
import { usePopups } from "@/store/popups";
import { useUserCreate } from "@/store/User";
import { RegisterApi } from "@/service/register";
import ToastV2 from "@/components/common/BaseToast";
import { clearInvitationData } from "@/handle/util/urlUtil";
import { openLink } from "@/handle/route";
const isCodeResponse = res => {
  return !!res && res.code;
};
export const useLoginSuccessCallback = () => {
  const popupDispatch = usePopups(state => state.dispatch);
  const userDispatch = useUserCreate(state => state.dispatch);
  const loginGoogleSuccessCallback = useCallback(async response => {
    if (isCodeResponse(response)) {
      try {
        const loginRes = await RegisterApi.postLogin({
          credential: response.code
        }, "google");
        if (loginRes.code === 0) {
          popupDispatch({
            type: "closeStack"
          });
          ToastV2.success("Login succeeded", 800, () => {
            userDispatch({
              type: "updateUserInfo",
              payload: loginRes.data
            });
          });
          getUserInfoByInit(true);
          clearInvitationData();
          openLink("");
        } else {
          ToastV2.error(loginRes.msg);
        }
      } catch (error) {
        console.log(error);
      }
    }
  }, []);
  return [loginGoogleSuccessCallback];
};